import React from "react";
import { Avatar } from "../avatar/Avatar";
import { Flex } from "./FlexHelpers";
import { PopupMenuCustomButton } from "./PopupMenuCustomButton";

export type StatusColorPopupMenuButtonProps = {
    options: { text: string, value: string, color: string }[],
    selectedValue?: string,
    onChange: (value: string) => void,
    disabled?: boolean,
}
export function StatusColorPopupMenuButton(props: StatusColorPopupMenuButtonProps): JSX.Element
{
    return (
        <PopupMenuCustomButton
            disabled={props.disabled}
            buttonContent={
                <Avatar
                    size="14px"
                    backgroundColor={props.options.find(option => option.value === props.selectedValue)?.color ?? 'transparent'}
                />
            }
            entries={props.options.map(option => ({
                type: 'menuItem',
                content: (
                    <StatusOption
                        text={option.text}
                        value={option.value}
                        color={option.color}
                    />
                ),
                onClick: () => props.onChange(option.value)
            }))}
        />
    );
}

function StatusOption(props:{ text: string, value: string, color: string }): JSX.Element
{
    return (
        <Flex flexDirection="row" alignItems="center" gap={4}>
            <Avatar
                size="14px"
                backgroundColor={props.color}>
            </Avatar>
            <span style={{ fontSize: 14 }}>{props.text}</span>
        </Flex>
    );
}